<template>
  <div class="assign-interview-user">
    <div class="header">
      <router-link
        tag="i"
        to="questionSetting?id=5"
        class="icon wjpc-iconfont wjpc-icon-arrow-left-bold"
      ></router-link>
      <span class="title">分配访员</span>
    </div>
    <div class="main">
      <el-container>
        <el-aside class="aside" width="298px">
          <div class="aside-header">
            全部访员
          </div>
          <ul class="list">
            <li class="list-item" v-for="user in i_users" :key="user.id">
              <span>{{ user.username }}</span>
              <span v-if="is_assigned(user)">已分配</span>
              <span  v-else @click="assignInterviewerUser(user)" style="color:#009EF8;" class="icon wjpc-iconfont wjpc-icon-jia1"></span>
            </li>
          </ul>
          <div class="page-wrapper">
            <el-pagination
              small
              background
              layout="prev, pager, next"
              :pager-count="5"
              :current-page="left_page.pageIndex"
              :total="left_page.total"
              @current-change="handleLeftPageChange"
            >
            </el-pagination>
          </div>
        </el-aside>
        <el-main class="content">
          <el-table
            :data="assigned_user_current_page"
            tooltip-effect="dark"
            border="border"
            header-row-class-name="thead-cell"
          >
				    <el-table-column prop="username" label="访员姓名"></el-table-column>
            <el-table-column prop="contactNumber" label="手机号"></el-table-column>
            <el-table-column prop="email" label="电子邮箱"></el-table-column>
            <el-table-column label="操作" width="240">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="unAssignInterviewerUser(scope)">移除</el-button>
              </template>
            </el-table-column>

          </el-table>
          <el-pagination
            small
            background
            layout="prev, pager, next"
            :current-page="right_page_computed.pageIndex"
            :total="right_page_computed.total"
            @current-change="handleRightPageChange"
          >
          </el-pagination>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
function pagination(pageNo, pageSize, array) {
  var offset = (pageNo - 1) * pageSize;
  return (offset + pageSize >= array.length) ? array.slice(offset, array.length) : array.slice(offset, offset + pageSize);
}
export default {
  data() {
    return {
      i_users: [],
      assigned_users: [],
      wj_id: "",
      left_page: {
        pageCount: 1,
        pageIndex: 1,
        pageSize: 10,
        total: 1,
      },
      right_page: {
        pageCount: 1,
        pageIndex: 1,
        pageSize: 10,
        total: 1,
      },
      right_page_computed: {
        pageCount: 1,
        pageIndex: 1,
        pageSize: 10,
        total: 1,
      },
    };
  },
  computed: {
    assigned_user_ids() {
      return this.assigned_users.map((user) => user.userId);
    },
    assigned_user_current_page(){
      return pagination(this.right_page_computed.pageIndex,this.right_page_computed.pageSize,this.assigned_users);
    }
  },
  mounted() {
    this.wj_id = this.$route.query.wj_id;
    this.loadInterviewerUserDatas();
    this.queryAssignInterviewUser();
  },
  methods: {
    is_assigned(user) {
      return this.assigned_user_ids.includes(user.userId);
    },
    loadInterviewerUserDatas() {
      this.$api
        .InterviewerUserList(
          this.left_page.pageIndex,
          this.left_page.pageSize,
          ""
        )
        .then((data) => {
          this.i_users = data.resultBody.datas;
          let { pageCount, pageIndex, pageSize, total } = data.resultBody;
          this.left_page = Object.assign({}, this.page, {
            pageCount,
            pageIndex,
            pageSize,
            total,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    queryAssignInterviewUser() {
      this.$api
        .QueryAssignInterviewUser(1,500, this.wj_id)
        .then((data) => {
          this.assigned_users = data.resultBody.datas;
          let { pageCount, pageIndex, pageSize, total } = data.resultBody;
          this.right_page = Object.assign({}, this.page, {
            pageCount,
            pageIndex,
            pageSize,
            total,
          });

          this.right_page_computed.total = total;
          this.right_page_computed.pageSize=10;
          this.right_page_computed.pageCount = Math.ceil(total/10);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    assignInterviewerUser(user) {
      let data = {
        interviewerUserList: [user.userId],
        questionnaireId: this.wj_id,
      };

      this.$api
        .AssignInterviewUser(data)
        .then((data) => {
          // console.log(data);
          this.loadInterviewerUserDatas();
          this.queryAssignInterviewUser();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    unAssignInterviewerUser(scope) {
      let data = {
        interviewerUserList: [scope.row.id],
      };

      this.$api
        .UnAssignInterviewUser(data)
        .then((data) => {
          // console.log(data);
          this.assigned_users.splice(scope.$index,1);
          this.loadInterviewerUserDatas();
          this.queryAssignInterviewUser();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleLeftPageChange(page) {
      this.left_page.pageIndex = page;
      this.loadInterviewerUserDatas();
    },
    handleRightPageChange(page) {
      this.right_page_computed.pageIndex = page;
    },
  },
};
</script>

<style lang="scss">
.assign-interview-user {
  width: 100%;
  min-height: 100%;
  background-color: #f5f5f5;
  .header {
    height: 68px;
    line-height: 68px;
    background-color: #fff;
    text-align: center;
    .icon{
      float: left;
      margin-left: 30px;
      font-size: 16px;
    }
    .title{
      font-size: 16px;
      color: #333;
    }
  }
  .main{
    width: 1280px;
    margin: 60px auto;
    padding: 40px;
    background-color: #fff;
    box-sizing: border-box;

    .aside{
      position: relative;
      display: flex;
      /* justify-content: center; */
      align-items: center;
      flex-direction: column;
      border: 1px solid #EBEEF5;
      padding-bottom: 30px;
      .aside-header{
        background-color: #f5f5f5;
        width: 100%;
        box-sizing: border-box;
        padding: 12px 10px;
        font-size: 14px;
        font-weight: bold;
        color: #333;
      }
      .list{
        width: 100%;
        .list-item{
          padding: 12px 10px;
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #EBEEF5;
        }
      }
      .page-wrapper{
        position: absolute;
        bottom: 0;
      }
    }
    .content{
      padding: 0;
      margin-left: 40px;
      // background-color: #acd;
      padding-bottom: 30px;
      .thead-cell th{
        background-color: #f5f5f5;
        color: #333;
      }
    }
  }
}



</style>
